import { conversionUtils } from '@/server-data'
import { type ResourceModel } from '@bryntum/schedulerpro'

import { getSchedulerPreferences } from '../../utils/getSchedulerPreferences'

import { DoubleColumnContainer } from '../Scheduler/components/DoubleColumnContainer'
import { SingleColumnContainer } from '../Scheduler/components/SingleColumnContainer'
import { Typography } from '../Scheduler/components/Typography'

interface Props {
  language: uui.domain.Language
  record: ResourceModel
  field: string
  value: uui.domain.client.rm.SchedulerResource['stopsCount']
}

export function StopsCell(props: Props) {
  const { value, language } = props

  const { showApprovedRoutes } = getSchedulerPreferences()

  const formatNumber = Intl.NumberFormat(conversionUtils.intlFormat[language]).format
  const stops = value.current >= 0 ? value.current : '-'

  const approvedStops =
    value.approved === null || value.approved === -1 ? '-' : formatNumber(value.approved)

  if (showApprovedRoutes && value.approved) {
    return (
      <DoubleColumnContainer
        firstRow={<Typography fontSize={12}>{stops}</Typography>}
        secondRow={<Typography fontSize={10}>{approvedStops}</Typography>}
      />
    )
  }

  return (
    <SingleColumnContainer>
      <Typography fontSize={12}>{stops}</Typography>
    </SingleColumnContainer>
  )
}
